export default __webpack_public_path__ + "static/media/ShopPressImg.dd801d85.jpg";